import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { TablerIconsModule } from 'angular-tabler-icons';
import moment from 'moment';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { AuthSessionDto } from 'src/app/app.models';
import { KendoModule } from 'src/app/kendo.module';
import { MaterialModule } from 'src/app/material.module';
import { CustomPipesModule } from 'src/app/pipe/customPipes.module';

@Component({
    selector     : 'clu-explicence-dialog',
    templateUrl  : './clu-explicence-dialog.component.html',
    styleUrls: ['./clu-explicence-dialog.component.scss'],
    standalone: true,
    encapsulation: ViewEncapsulation.None,
    imports: [FormsModule, MaterialModule, KendoModule, TranslateModule, TablerIconsModule, NgScrollbarModule, CustomPipesModule],
    providers : []
})
export class CluExpLicenceDialogComponent implements OnInit 
{
    authSessionDto : AuthSessionDto;
    daysLeft : number = 0;
    constructor(@Inject(MAT_DIALOG_DATA) private dataE: any, public matDialogRef: MatDialogRef<CluExpLicenceDialogComponent>){
        this.authSessionDto = this.dataE.authSessionDto;
        this.daysLeft = this.dataE.daysLeft;
    }

    ngOnInit() { }  
    
}